import './RankingsBoxTable.css'

import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { withTranslation } from 'react-i18next'

import { ORDER, RANKINGS } from './constants'
import RankingsBoxTableDetailsHeader from './RankingsBoxTableDetailsHeader'
import RankingsBoxTableDetailsRow from './RankingsBoxTableDetailsRow'
import RankingsBoxTableIndicatorHeader from './RankingsBoxTableIndicatorHeader'
import RankingsBoxTableIndicatorRow from './RankingsBoxTableIndicatorRow'
import { getColumnsPerRanking } from './utils'

const getTitleToTranslatePerRanking = ranking => {
  switch (ranking) {
    case RANKINGS.COMPANIES_BY_CHANNELS:
    case RANKINGS.COMPANIES_ECOMMERCE:
    case RANKINGS.COMPANIES_STATIONARY:
      return 'rankings.companies'

    case RANKINGS.DISTRICT:
      return 'rankings.district'

    case RANKINGS.RKS:
      return 'rankings.rks'

    case RANKINGS.WEBSITE_ECOMMERCE:
      return 'rankings.websites'

    case RANKINGS.BEST_20_SHOPS:
    case RANKINGS.WORST_20_SHOPS:
    case RANKINGS.STORES_OPEN_WITHIN_30_DAYS:
    case RANKINGS.STORES_OPEN_WITHIN_12_MONTHS:
    default:
      return 'rankings.shop'
  }
}

class RankingsBoxTable extends PureComponent {
  render() {
    const { indicator, onSort, ranking, rankingsCountries, sort, t } = this.props
    const maxIndicator = Math.max(...rankingsCountries.map(rankingCountry => rankingCountry[indicator]))
    const maxRevenuePerStoreCurrent = Math.max(...rankingsCountries.map(rankingCountry => rankingCountry.revenuePerStoreCurrent))
    const maxTrafficCurrent = Math.max(...rankingsCountries.map(rankingCountry => rankingCountry.trafficCurrent))
    const maxRevenueCurrent = Math.max(...rankingsCountries.map(rankingCountry => rankingCountry.revenueCurrent))
    const maxRevenuePerM2Current = Math.max(...rankingsCountries.map(rankingCountry => rankingCountry.revenuePerM2Current))
    const hideFlag = rankingsCountries.length > 0 && typeof rankingsCountries[0].countryId !== 'number'
    const columns = getColumnsPerRanking(ranking)

    return (
      <div className="rankings-box-table flex-row">
        <div className="rankings-box-table-indicator">
          <RankingsBoxTableIndicatorHeader
            hideFlag={hideFlag}
            indicator={indicator}
            onSort={onSort}
            sort={sort}
            title={t(getTitleToTranslatePerRanking(ranking))}
          />

          {rankingsCountries.map(country => (
            <RankingsBoxTableIndicatorRow
              key={`${country.countryId}-${country.rank}`}
              data={country}
              indicator={indicator}
              maxIndicator={maxIndicator}
            />
          ))}
        </div>

        <div className="rankings-box-table-details">
          <RankingsBoxTableDetailsHeader columns={columns} indicator={indicator} onSort={onSort} sort={sort} />

          {rankingsCountries.map(country => (
            <RankingsBoxTableDetailsRow
              key={`${country.countryId}-${country.rank}`}
              columns={columns}
              data={country}
              indicator={indicator}
              maxRevenueCurrent={maxRevenueCurrent}
              maxRevenuePerStoreCurrent={maxRevenuePerStoreCurrent}
              maxTrafficCurrent={maxTrafficCurrent}
              maxRevenuePerM2Current={maxRevenuePerM2Current}
            />
          ))}
        </div>
      </div>
    )
  }
}

RankingsBoxTable.propTypes = {
  indicator: PropTypes.string,
  onSort: PropTypes.func.isRequired,
  ranking: PropTypes.string,
  rankingsCountries: PropTypes.arrayOf(PropTypes.object),
  sort: PropTypes.shape({
    order: PropTypes.oneOf([ORDER.ASC, ORDER.DESC]),
    sortBy: PropTypes.string,
  }),
  t: PropTypes.func,
}

export default withTranslation()(RankingsBoxTable)
